import React from 'react';
import { buildUrlAndOpenSameWindow } from 'app/utilities/StringHelpers/StringHelpers';

function ResolvedStatus({ text , urlButtonText , urlButton}) {

  const handleClick = (event) => {
    event.preventDefault();
    buildUrlAndOpenSameWindow(urlButton);
  };

  return (
    <div className='resolved-status'>
      <div className="status-update-time">{text}</div>
      {urlButtonText && urlButton && (
        <div className='private-area-link-wrapper'>
          <a
            href='javascript: void(0)'
            className='private-area-link'
            onClick={handleClick}
          >
            {urlButtonText}
          </a>
        </div>
      )}
    </div>
  );
}

export default ResolvedStatus;
